export interface BlogImageMeta {
  width: number;
  height: number;
  srcSet?: string;
}

// Intrinsic dimensions (and responsive variants) for blog images served from public/.
// Register every new blog image here so posts render with width/height (no layout
// shift) and a srcSet. Generate the -800w variant with:
//   sips --resampleWidth 800 -s format jpeg -s formatOptions 78 public/<img> --out public/<name>-800w.<ext>
const blogImageMeta: Record<string, BlogImageMeta> = {
  '/blog-adults-only-travel.jpg': {
    width: 2048,
    height: 1363,
    srcSet: '/blog-adults-only-travel-800w.jpg 800w, /blog-adults-only-travel.jpg 2048w',
  },
  '/blog-best-cities-leaderboard.png': { width: 600, height: 1200 },
  '/blog-childfree-loneliness.jpeg': {
    width: 1204,
    height: 1600,
    srcSet: '/blog-childfree-loneliness-800w.jpeg 800w, /blog-childfree-loneliness.jpeg 1204w',
  },
  '/blog-choosing-childfree.jpeg': {
    width: 1600,
    height: 900,
    srcSet: '/blog-choosing-childfree-800w.jpeg 800w, /blog-choosing-childfree.jpeg 1600w',
  },
  '/blog-digital-nomad.jpeg': {
    width: 1800,
    height: 1350,
    srcSet: '/blog-digital-nomad-800w.jpeg 800w, /blog-digital-nomad.jpeg 1800w',
  },
  '/blog-dink-economy-cover.jpg': {
    width: 1600,
    height: 1066,
    srcSet: '/blog-dink-economy-cover-800w.jpg 800w, /blog-dink-economy-cover.jpg 1600w',
  },
  '/blog-dink-fire.jpeg': {
    width: 1600,
    height: 1060,
    srcSet: '/blog-dink-fire-800w.jpeg 800w, /blog-dink-fire.jpeg 1600w',
  },
  '/blog-dink-statistics-cover.png': { width: 1344, height: 768 },
  '/blog-making-friends-30s.jpeg': {
    width: 1600,
    height: 1066,
    srcSet: '/blog-making-friends-30s-800w.jpeg 800w, /blog-making-friends-30s.jpeg 1600w',
  },
  '/blog-national-pet-day.jpg': {
    width: 1200,
    height: 630,
    srcSet: '/blog-national-pet-day-800w.jpg 800w, /blog-national-pet-day.jpg 1200w',
  },
  '/blog-regret.jpg': {
    width: 2000,
    height: 1335,
    srcSet: '/blog-regret-800w.jpg 800w, /blog-regret.jpg 2000w',
  },
  '/blog-regret-older-couple.jpg': {
    width: 1600,
    height: 1066,
    srcSet: '/blog-regret-older-couple-800w.jpg 800w, /blog-regret-older-couple.jpg 1600w',
  },
  '/blog-roscoe-and-remy.jpg': {
    width: 1200,
    height: 1600,
    srcSet: '/blog-roscoe-and-remy-800w.jpg 800w, /blog-roscoe-and-remy.jpg 1200w',
  },
};

// Accepts src values that carry a width-hint fragment (e.g. /photo.jpg#w600)
export function getBlogImageMeta(src?: string): BlogImageMeta | undefined {
  if (!src) return undefined;
  return blogImageMeta[src.split('#')[0]];
}
